// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1Yz6M","title":"ClientCherryInfo_title__2KHnw","itemText":"ClientCherryInfo_itemText__1ZO2q"};